/* eslint-disable react/prop-types */
import styles from './styles.module.css'

export const RoundedProgressBarCard = ({
  parameterPercent,
  percentString,
  onClick,
  btnText,
  label,
  title,
  bodyText
}) => {
  return (
    <div className={styles.modal_box_main}>
      <div  className={styles.modal_box_mid}>
        <div className={styles.progress_circle}>
          <svg className={styles.circle}>
            <circle className={styles.bg} cx="50" cy="50" r="45" />
            <circle
              className={styles.progress}
              cx="50"
              cy="50"
              r="45"
              style={{
                strokeDasharray: 282.74,
                strokeDashoffset: 282.74 * (1 - parameterPercent),
              }}
            />
          </svg>
          <div className={styles.percentage}>{percentString + '%'}</div>
        </div>
        <div className={styles.text_group}>
          <div className={styles.modal_top_text}>
            <p>{label}</p>
          </div>
          <div className={styles.modal_bottom_text}>
            <h5>
              {title}
            </h5>
            <p>{bodyText}</p>
          </div>
        </div>
      </div>
      <div className={styles.action_group}>
        <div className={styles.box_button_paratization}>
          <button
            className={styles.button_paratization}
            onClick={onClick}
          >
            {btnText}
          </button>
        </div>
      </div>
    </div>
  )
}
